import { library } from "@fortawesome/fontawesome-svg-core";
import { faPowerOff, faExclamation, faDollarSign, faCheck } from "@fortawesome/free-solid-svg-icons";

function initFontAwesome() {
  library.add(faPowerOff, faExclamation, faDollarSign, faCheck);
}

export default initFontAwesome;
